import { render, staticRenderFns } from "./IntroductionCard.vue?vue&type=template&id=718eaa16&scoped=true"
import script from "./IntroductionCard.vue?vue&type=script&lang=js"
export * from "./IntroductionCard.vue?vue&type=script&lang=js"
import style0 from "./IntroductionCard.vue?vue&type=style&index=0&id=718eaa16&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718eaa16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718eaa16')) {
      api.createRecord('718eaa16', component.options)
    } else {
      api.reload('718eaa16', component.options)
    }
    module.hot.accept("./IntroductionCard.vue?vue&type=template&id=718eaa16&scoped=true", function () {
      api.rerender('718eaa16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/self-select-stock/components/IntroductionCard.vue"
export default component.exports